import script from "./circuit.vue?vue&type=script&setup=true&lang=js"
export * from "./circuit.vue?vue&type=script&setup=true&lang=js"

import "./circuit.vue?vue&type=style&index=0&id=38666472&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38666472"]])

export default __exports__